import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'

const RepaymentDefaultsModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted, status,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  defaultDate, onDefaultDateChange, defaultDateError, setDefaultDateError,
  cureDate, onCureDateChange, cureDateError, setCureDateError,
  defaultReason, onDefaultReasonChange, defaultReasonError, setDefaultReasonError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add defaults'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {
      status === 'unpaid' &&
      <>
        <InputDateUI context={context} name='ddate' label='Default date'
          selectedDateISO={defaultDate} onChange={onDefaultDateChange}
          error={defaultDateError} setError={setDefaultDateError}
        />
        <InputDateUI context={context} name='cdate' label='Cure date'
          selectedDateISO={cureDate} onChange={onCureDateChange}
          error={cureDateError} setError={setCureDateError}
        />
        <InputTextAreaSF type='text' name='defaultReason' label='Default reason'
          value={defaultReason} onChange={onDefaultReasonChange}
          error={defaultReasonError} setError={setDefaultReasonError}
          help='200 characters max, address the client'
        />
      </>
    }

  </ModalFormUI>

export default RepaymentDefaultsModalUI
